/* Tightknit PDP — variant sync, cart submission, analytics.
   Catch-all visual clone. Tracks Meta Pixel + GA4 dataLayer + Shopify Customer Events.
   Defensive: every external integration is feature-detected. */

(function () {
  'use strict';

  const pdp = document.getElementById('pdp');
  if (!pdp) return;

  const productJsonEl = document.getElementById('pdp-product-json');
  if (!productJsonEl) return;

  let product;
  try { product = JSON.parse(productJsonEl.textContent); } catch (e) { console.error('[pdp] bad product JSON', e); return; }

  const form          = document.getElementById('pdp-product-form');
  const variantInput  = document.getElementById('pdp-variant-id');
  const quantityInput = document.getElementById('pdp-quantity');
  const atcBtn        = document.getElementById('pdp-atc');
  const atcLabel      = document.getElementById('pdp-atc-label');
  const shadeCurrent  = document.getElementById('pdp-shade-current');
  const mainImage     = document.getElementById('pdp-main-image');
  const stickyBar     = document.getElementById('pdp-stickybar');
  const stickyPrice   = document.getElementById('pdp-stickybar-price');
  const stickyCta     = document.getElementById('pdp-stickybar-cta');
  const addonInputs   = pdp.querySelectorAll('.pdp__addon input[type="checkbox"]');

  // ----- helpers ------------------------------------------------------------

  const money = (cents) => {
    if (cents == null) return '';
    const n = cents / 100;
    return '$' + (Number.isInteger(n) ? n.toFixed(0) : n.toFixed(2).replace(/\.?0+$/, ''));
  };

  const getSelectedOptions = () => {
    const checked = (name) => {
      const el = form.querySelector(`input[name="options[${name}]"]:checked`);
      return el ? el.value : null;
    };
    return product.options.map((name) => checked(name));
  };

  const findVariant = (selected) =>
    product.variants.find((v) => v.options.every((val, i) => val === selected[i]));

  const selectedAddons = () =>
    Array.from(addonInputs)
      .filter((input) => input.checked)
      .map((input) => {
        const label = input.closest('.pdp__addon');
        return {
          variant_id: parseInt(label.dataset.variantId, 10),
          price_cents: parseInt(label.dataset.addonPriceCents, 10) || 0,
        };
      });

  const addonsSumCents = () => selectedAddons().reduce((sum, a) => sum + a.price_cents, 0);

  const getSelectedBundleRow = () => pdp.querySelector('.bundle-row--selected');

  const getSelectedPackQty = () => {
    const row = getSelectedBundleRow();
    if (row && row.dataset.packQty) return parseInt(row.dataset.packQty, 10) || 1;
    return parseInt(quantityInput.value, 10) || 1;
  };

  const getSelectedPackFinalCents = () => {
    const row = getSelectedBundleRow();
    if (row && row.dataset.packFinalCents) return parseInt(row.dataset.packFinalCents, 10);
    return null;
  };

  const totalCents = (variant) => {
    if (!variant || !variant.available) return addonsSumCents();
    const finalCents = getSelectedPackFinalCents();
    const qty = getSelectedPackQty();
    const variantTotal = finalCents != null ? finalCents : variant.price * qty;
    return variantTotal + addonsSumCents();
  };

  // ----- variant sync -------------------------------------------------------

  let currentVariant = product.variants.find((v) => v.id === parseInt(variantInput.value, 10))
    || product.variants.find((v) => v.available)
    || product.variants[0];

  const updateForVariant = (variant) => {
    currentVariant = variant;

    if (variant) {
      variantInput.value = variant.id;
      atcBtn.disabled = !variant.available;

      if (variant.available) {
        atcLabel.innerHTML = 'Add to Cart · <span id="pdp-atc-price">' + money(totalCents(variant)) + '</span>';
      } else {
        atcLabel.textContent = 'Sold out';
      }

      if (stickyPrice) stickyPrice.textContent = money(totalCents(variant));

      if (variant.featured_image && variant.featured_image.src && mainImage) {
        const url = variant.featured_image.src.replace(/(\.[^.\/?]+)(\?.*)?$/, '_1400x$1$2');
        mainImage.style.backgroundImage = `url('${url}')`;
      }

      pushDataLayer('select_item', {
        item_list_id: 'pdp_variant_select',
        items: [variantToItem(variant)],
      });
    } else {
      atcBtn.disabled = true;
      atcLabel.textContent = 'Unavailable';
    }
  };

  const onOptionChange = () => {
    const selected = getSelectedOptions();
    const variant = findVariant(selected);

    if (shadeCurrent) {
      let shadeIdx = product.options.indexOf('Shade');
      if (shadeIdx < 0) shadeIdx = product.options.indexOf('Color');
      if (shadeIdx < 0) shadeIdx = product.options.indexOf('Colour');
      if (shadeIdx >= 0 && selected[shadeIdx]) shadeCurrent.textContent = selected[shadeIdx];
    }

    updateForVariant(variant);
  };

  // ----- click delegation ---------------------------------------------------

  pdp.addEventListener('click', (e) => {
    const swatch = e.target.closest('.swatch-circle');
    const square = e.target.closest('.size-square');
    const row    = e.target.closest('.bundle-row');

    if (swatch) {
      const input = swatch.querySelector('input[type="radio"]');
      if (input && !input.checked) {
        input.checked = true;
        document.querySelectorAll('.swatch-circle').forEach((el) => el.classList.remove('swatch-circle--selected'));
        swatch.classList.add('swatch-circle--selected');
        onOptionChange();
      }
      repaintGalleryForShade(swatch.dataset.color);
    }

    if (square) {
      const input = square.querySelector('input[type="radio"]');
      if (input && !input.checked) {
        input.checked = true;
        document.querySelectorAll('.size-square').forEach((el) => el.classList.remove('size-square--selected'));
        square.classList.add('size-square--selected');
        onOptionChange();
      }
    }

    if (row) {
      document.querySelectorAll('.bundle-row').forEach((el) => el.classList.remove('bundle-row--selected'));
      row.classList.add('bundle-row--selected');
      const packQty = parseInt(row.dataset.packQty, 10) || 1;
      quantityInput.value = String(packQty);
      updateForVariant(currentVariant);
    }
  });

  // ----- addon checkboxes → recompute ATC + sticky price -------------------

  addonInputs.forEach((input) => {
    input.addEventListener('change', () => updateForVariant(currentVariant));
  });

  // ----- gallery thumbs -----------------------------------------------------

  const mainVideo = document.getElementById('pdp-main-video');

  function showImage(src) {
    if (mainImage) {
      mainImage.style.backgroundImage = `url('${src}')`;
      mainImage.hidden = false;
    }
    if (mainVideo) {
      try { mainVideo.pause(); } catch (e) {}
      mainVideo.hidden = true;
    }
  }
  function showVideo(src) {
    if (!mainVideo) return;
    if (mainImage) mainImage.hidden = true;
    // Lazy-attach the source on first play to avoid pre-loading on initial paint
    const source = mainVideo.querySelector('source');
    if (source && !source.src && source.dataset.src) source.src = source.dataset.src;
    if (source && !source.src && src) source.src = src;
    if (!mainVideo.src && !mainVideo.querySelector('source[src]') && src) {
      mainVideo.src = src;
    }
    mainVideo.hidden = false;
    mainVideo.load();
    const p = mainVideo.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  }

  pdp.addEventListener('click', (e) => {
    const thumb = e.target.closest('.pdp__thumb');
    if (!thumb) return;
    document.querySelectorAll('.pdp__thumb').forEach((el) => el.classList.remove('pdp__thumb--active'));
    thumb.classList.add('pdp__thumb--active');
    const videoSrc = thumb.dataset.video;
    if (videoSrc) {
      showVideo(videoSrc);
      return;
    }
    const fullSrc = thumb.dataset.img;
    if (fullSrc) showImage(fullSrc);
  });

  // ----- gallery repaint on shade change -----------------------------------

  const galleryEl = pdp.querySelector('.pdp__gallery');
  let shadeImages = null;
  if (galleryEl && galleryEl.dataset.shadeImages) {
    try { shadeImages = JSON.parse(galleryEl.dataset.shadeImages); } catch (e) { shadeImages = null; }
  }
  function repaintGalleryForShade(color) {
    if (!shadeImages || !color) return;
    const key = String(color).toLowerCase();
    let imgs = null;
    if (key.indexOf('nude') >= 0) imgs = shadeImages.nude;
    else if (key.indexOf('tan') >= 0) imgs = shadeImages.tan;
    else imgs = shadeImages.black;
    if (!imgs || !imgs.length) return;
    // Only repaint image thumbs — video thumb keeps its poster.
    const thumbs = document.querySelectorAll('.pdp__thumb:not(.pdp__thumb--video)');
    thumbs.forEach((t, i) => {
      const url = imgs[i] || imgs[0];
      t.dataset.img = url;
      t.style.backgroundImage = `url('${url}')`;
      t.classList.toggle('pdp__thumb--active', i === 0);
    });
    // Reset active state on the video thumb if any
    document.querySelectorAll('.pdp__thumb--video').forEach((v) => v.classList.remove('pdp__thumb--active'));
    showImage(imgs[0]);
  }

  // ----- analytics ----------------------------------------------------------

  const variantToItem = (v) => ({
    item_id: String(v.id),
    item_name: product.title,
    item_brand: 'Tightknit',
    item_variant: v.title,
    price: v.price / 100,
    quantity: 1,
  });

  const pushDataLayer = (event, payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ecommerce: { currency: 'USD', ...payload } });
  };

  // Vendor-neutral CustomEvent — Web Pixels subscribe via document.addEventListener.
  const willaEvent = (name, detail) => {
    try { document.dispatchEvent(new CustomEvent('willa:' + name, { detail })); } catch (e) { /* noop */ }
  };

  if (currentVariant) {
    pushDataLayer('view_item', {
      value: currentVariant.price / 100,
      items: [variantToItem(currentVariant)],
    });
    willaEvent('view_content', {
      handle: product.handle,
      variant_id: currentVariant.id,
      price: currentVariant.price / 100,
      currency: 'USD',
    });
    if (typeof window.analytics === 'object' && typeof window.analytics.publish === 'function') {
      try {
        window.analytics.publish('product_viewed', {
          productVariant: {
            id: String(currentVariant.id),
            price: { amount: currentVariant.price / 100, currencyCode: 'USD' },
            product: { id: String(product.id), title: product.title, vendor: 'Tightknit' },
            sku: currentVariant.sku || null,
          },
        });
      } catch (e) { /* noop */ }
    }
  }

  // ----- form submit → AJAX add → tracking → redirect ----------------------

  /* Both the form submit and the sticky CTA call this, and neither disabled the
     button — a double-tap added the item twice and double-fired add_to_cart.
     One guard on the shared entry point covers both. */
  let atcInflight = false;
  const submitAdd = async (variant) => {
    if (atcInflight) return;
    atcInflight = true;
    if (atcBtn) atcBtn.disabled = true;
    try { await submitAddRaw(variant); }
    finally { atcInflight = false; if (atcBtn) atcBtn.disabled = false; }
  };
  const submitAddRaw = async (variant) => {
    if (!variant || !variant.available) return;

    const qty = parseInt(quantityInput.value, 10) || 1;
    const addons = selectedAddons();
    const items = [{ id: variant.id, quantity: qty }].concat(
      addons.map((a) => ({ id: a.variant_id, quantity: 1 }))
    );

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        const errText = await res.text().catch(() => '');
        console.error('[pdp] /cart/add.js failed', res.status, errText);
        atcLabel.textContent = 'Try again';
        setTimeout(() => updateForVariant(variant), 1500);
        return;
      }

      const finalCentsForAnalytics = getSelectedPackFinalCents();
      const bundleValueUsd = (finalCentsForAnalytics != null ? finalCentsForAnalytics : variant.price * qty) / 100;
      const perPairValueUsd = bundleValueUsd / qty;

      pushDataLayer('add_to_cart', {
        value: bundleValueUsd,
        items: [{ ...variantToItem(variant), price: perPairValueUsd, quantity: qty }],
      });
      willaEvent('add_to_cart', {
        handle: product.handle,
        variant_id: variant.id,
        price: perPairValueUsd,
        currency: 'USD',
        quantity: qty,
      });
      if (typeof window.analytics === 'object' && typeof window.analytics.publish === 'function') {
        try {
          window.analytics.publish('product_added_to_cart', {
            cartLine: {
              merchandise: {
                id: String(variant.id),
                price: { amount: variant.price / 100, currencyCode: 'USD' },
                product: { id: String(product.id), title: product.title, vendor: 'Tightknit' },
                sku: variant.sku || null,
              },
              quantity: qty,
            },
          });
        } catch (e) { /* noop */ }
      }

      // Open the cart drawer (no redirect to /cart). cart-drawer.js handles the refresh + slide-in.
      document.dispatchEvent(new CustomEvent('willa:cart_added'));
      // Reset the ATC label after a beat so the user knows the click landed.
      setTimeout(() => updateForVariant(variant), 600);
    } catch (e) {
      console.error('[pdp] add to cart error', e);
      atcLabel.textContent = 'Try again';
      setTimeout(() => updateForVariant(variant), 1500);
    }
  };

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      atcLabel.textContent = 'Adding…';
      submitAdd(currentVariant);
    });
  }

  if (stickyCta) {
    stickyCta.addEventListener('click', () => {
      atcLabel.textContent = 'Adding…';
      submitAdd(currentVariant);
    });
  }

  // ----- begin_checkout signal on quick-pay --------------------------------

  pdp.addEventListener('click', (e) => {
    const qp = e.target.closest('.quick-pay__btn');
    if (!qp || !currentVariant) return;

    pushDataLayer('begin_checkout', {
      value: currentVariant.price / 100,
      items: [variantToItem(currentVariant)],
    });
    willaEvent('begin_checkout', {
      handle: product.handle,
      variant_id: currentVariant.id,
      price: currentVariant.price / 100,
      currency: 'USD',
    });
    window.location.href = '/cart';
  });

  // ----- mobile sticky bar --------------------------------------------------

  if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('pdp-stickybar--visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          } else if (entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('pdp-stickybar--visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(atcBtn);
  }
})();
